import type { SVGProps } from 'react';

const SvgExternalOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.7 4.8a.9.9 0 1 1 0-1.8h5.4a.9.9 0 0 1 .9.9v5.4a.9.9 0 1 1-1.8 0V6.073l-8.364 8.363a.9.9 0 1 1-1.272-1.272L17.927 4.8zm-9 2.7a.9.9 0 0 0-.9.9v9.9a.9.9 0 0 0 .9.9h9.9a.9.9 0 0 0 .9-.9v-5.4a.9.9 0 1 1 1.8 0v5.4a2.7 2.7 0 0 1-2.7 2.7H5.7A2.7 2.7 0 0 1 3 18.3V8.4a2.7 2.7 0 0 1 2.7-2.7h5.4a.9.9 0 1 1 0 1.8z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgExternalOutlined;
